import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { networkStore } from 'stores'
import { theme } from 'theme'
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'

dayjs().format()
dayjs.extend(LocalizedFormat)

const CustomBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`

const DotStatus = styled(Box)`
  width: 12px;
  height: 12px;
  border-radius: 100%;
`

const BlockStatus = observer(() => {
  const { block } = networkStore
  // 10 Second (10000) is magic number that can be remove gab btw load and real
  const d = new Date().getTime() - block.timeStamp - 10000
  const dotColor = useMemo(() => {
    if (d > 15000) return theme.palette.error.main
    else if (d > 9000) return theme.palette.warning.main
    else return theme.palette.success.main
  }, [d])

  return (
    <CustomBox>
      <DotStatus sx={{ background: dotColor }} />
      <Typography variant="body2">
        Latest block : {block.height} | {dayjs(block.timeStamp).format('LTS')}
      </Typography>
    </CustomBox>
  )
})

export default BlockStatus
